import React, { Component } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import Bills from "./Bills";
import {Row, Card} from "reactstrap";
import "config";
import { connect } from "react-redux";

class Billsapp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      JsonObject: this.props.data,
      loading : true
    };
  }
  
  componentDidMount() {
    this.setState({
      loading: false
    })
  }

  render() {
    if(this.state.loading)
    {
      return null;
    }
    else
    {
      return (
        <React.Fragment>
          <button className="x" onClick={this.props.closebtn}>
            x
          </button>
          <div className="header">
            Bill details
          </div>
          <Row>
            <div className="col">
              <div className="Scrolls-Contents">
                <Card className="shadow">
                  <PDFViewer width="100%" height="600" className="app">
                    <Bills 
                      billData = {this.state.JsonObject}
                    />
                  </PDFViewer>
                </Card>
              </div>
            </div>
          </Row>
        </React.Fragment>
      );
    }
  }
}
const mapStateToProps = state => {
  return {
    token:state.token, 
  }
}
export default connect(mapStateToProps, null)(Billsapp);